
import React from 'react';
import { Layout, Menu, Typography, Avatar, Badge } from 'antd';
import { Link } from 'react-router-dom';
import './index.css';

const { Header: AntHeader } = Layout;
const { Title } = Typography;

const AppHeader = () => {
  return (
    <AntHeader className="app-header">
      <div className="header-content">
        {/* 左侧 Logo / 标题 */}
        <Title level={3} style={{ margin: 0 }}>
          <Link to="/" className="header-logo">我的博客</Link>
        </Title>

        {/* 中间导航菜单 */}
        <Menu
          theme="dark"  /* 改为 dark 主题 */
          mode="horizontal"
          selectedKeys={[window.location.pathname]}
          className="header-menu"
          style={{ 
            fontSize: '16px',
            color: '#ffffff'
          }}
          items={[
            { key: '/', label: <Link to="/">首页</Link> },
            { key: '/archive', label: <Link to="/archive">归档</Link> },
            { key: '/write', label: <Link to="/write">写文章</Link> },
            { key: '/about', label: <Link to="/about">我的</Link> },
          ]}
        />
              {/* 右侧用户操作区 */}
        <div className="header-right">
          <Badge count={3} size="small" offset={[8, -4]}>
            <Avatar shape="circle" icon={<i className="icon-bell"></i>} />
          </Badge>
          <Avatar shape="circle" src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png" />
        </div>
      </div>
    </AntHeader>
  );
};

export default AppHeader;